import { styled } from '@mui/material/styles';
import { IconButton as MuiIconButton, IconButtonProps as MuiIconButtonProps } from '@mui/material';

const TableActionButton = styled(MuiIconButton)<MuiIconButtonProps>(() => ({
	padding: '4px',
}));

export default TableActionButton;
